import axios from 'axios';
import * as apiConfig from './api-config';
import * as configuration from '../utils/configuration';
import * as Page500ErrorTypes from '../common/error-types-500';
import { ApiUrl } from './api-url';

configuration.setConfiguration(
  configuration.ApiServerKey.APP_API_ROOT,
  apiConfig.api
);
const apiRoot = configuration.getConfiguration(
  configuration.ApiServerKey.APP_API_ROOT
);

const isHandlerEnabled = true;

const requestHandler = (request) => {
  if (isHandlerEnabled) {
    // request.headers.common["Accept"] = "application/json";
    request.headers.common['Content-Type'] = 'application/json; charset=utf-8';
    request.headers.common['Accept'] =
      'application/json, text/javascript, */*; q=0.01';
    request.headers.common['Access-Control-Allow-Origin'] = '*';
  }

  let userInfo = configuration.getCookies(configuration.TokenKey.token);
  if (userInfo) {
    request.headers.common[
      'Authorization'
    ] = `${configuration.TokenPrefix} ${userInfo}`;
  }

  return request;
};

const successHandler = (response, isHandlerEnabled) => {
  if (isHandlerEnabled) {
    //TODO: Do Success Handler
  }

  return response;
};

const errorHandler = async (error, isHandlerEnabled) => {
  if (isHandlerEnabled) {
    //TODO: Do Error Handler
  }

  if (
    error.request.responseType === 'blob' &&
    error.response.data instanceof Blob &&
    error.response.data.type &&
    error.response.data.type.toLowerCase().indexOf('json') != -1
  ) {
    return new Promise((resolve, reject) => {
      let reader = new FileReader();
      reader.onload = () => {
        error.response.data = JSON.parse(reader.result);
        resolve(Promise.reject(error.response.data));
      };

      reader.onerror = () => {
        reject(error);
      };
      reader.readAsText(error.response.data);
    });
  }

  return Promise.reject({
    ...(error.response
      ? error.response.data
      : {
        errorType: Page500ErrorTypes.UnhandleException,
        errorMessage: 'UnhandleException',
      }),
  });
};

export default class Service {
  constructor(namespace) {
    this.namespace = namespace;
    this.axios = axios.create({
      baseURL: apiRoot,
      responseType: 'json',
    });

    //Enable request interceptor
    this.axios.interceptors.request.use(
      (request) => requestHandler(request, isHandlerEnabled),
      (error) => errorHandler(error, isHandlerEnabled)
    );

    //Response and Error handler
    this.axios.interceptors.response.use(
      (response) => successHandler(response, isHandlerEnabled),
      (error) => {
        const originalRequest = error.config;
        if (error && error.response && error.response.status && error.response.status === 401) {
          const accessToken = configuration.getCookies(configuration.TokenKey.token);
          const refreshToken = configuration.getCookies(configuration.TokenKey.refreshToken);
          const deviceId = configuration.getCookies(configuration.TokenKey.DeviceId);
          const data = {
            returnUrl: '',
            accessToken,
            refreshToken,
            deviceId
          }
          if (accessToken && refreshToken && deviceId) {
            this.post(ApiUrl.RefreshToken, data).then((res) => {
              configuration.setCookies(configuration.TokenKey.token, res.content.token);
              configuration.setCookies(configuration.TokenKey.refreshToken, res.content.refreshTokens);
            }).then(() => {
              const accessToken = configuration.getCookies(configuration.TokenKey.token);
              originalRequest.headers.Authorization = `${configuration.TokenPrefix} ${accessToken}`;
              return axios(originalRequest);
            }).catch(() => {
              configuration.removeCookies(configuration.TokenKey.token);
              configuration.removeCookies(configuration.TokenKey.DeviceId);
              configuration.removeCookies(configuration.TokenKey.refreshToken);
              configuration.setCookies("SHOW_FORM_LOGIN", true);
              configuration.setCookies("IS_ADMIN", false);
            })
          }
        }
        return Promise.reject(error);
      }
    );
  }

  /**
   * Get Http Request
   * @param {any} action
   */
  get(action, params) {
    return new Promise((resolve, reject) => {
      this.axios
        .request(params ? action + '?' + params : action, {
          method: 'GET',
        })
        .then((response) => {
          if (response.data) {
            resolve(response.data);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          if (
            error.response &&
            error.response.data &&
            error.response.data.error
          ) {
            console.error('REST request error!', error.response.data.error);
            reject(error.response.data.error);
          } else reject(error);
        });
    });
  }

  /**
   * Get Http Request
   * @param {any} action
   */
  getBinary(action, params) {
    return new Promise((resolve, reject) => {
      this.axios
        .request(params ? action + '?' + params : action, {
          method: 'GET',
          responseType: 'blob',
        })
        .then((response) => {
          if (response.data) {
            resolve(response.data);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          if (
            error.response &&
            error.response.data &&
            error.response.data.error
          ) {
            console.error('REST request error!', error.response.data.error);
            reject(error.response.data.error);
          } else reject(error);
        });
    });
  }

  /**
   * Post Http Request
   * @param {any} action
   * @param {any} params
   */
  post(action, params) {
    return new Promise((resolve, reject) => {
      this.axios
        .request(action, {
          method: 'POST',
          data: params,
        })
        .then((response) => {
          if (response.data) {
            resolve(response.data);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          if (
            error.response &&
            error.response.data &&
            error.response.data.error
          ) {
            console.error('REST request error!', error.response.data.error);
            reject(error.response.data.error);
          } else reject(error);
        });
    });
  }

  /**
   * Put Http Request
   * @param {any} action
   * @param {any} params
   */
  put(action, params) {
    return new Promise((resolve, reject) => {
      this.axios
        .request(action, {
          method: 'PUT',
          data: params,
        })
        .then((response) => {
          if (response.data) {
            resolve(response.data);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          if (
            error.response &&
            error.response.data &&
            error.response.data.error
          ) {
            console.error('REST request error!', error.response.data.error);
            reject(error.response.data.error);
          } else reject(error);
        });
    });
  }

  /**
   * Post Http Request
   * @param {any} action
   * @param {any} params
   */
  postParams(action, params, body) {
    return new Promise((resolve, reject) => {
      this.axios
        .request(action + '?' + params, {
          method: 'POST',
          data: body,
        })
        .then((response) => {
          if (response.data) {
            resolve(response.data);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          if (
            error.response &&
            error.response.data &&
            error.response.data.error
          ) {
            console.error('REST request error!', error.response.data.error);
            reject(error.response.data.error);
          } else reject(error);
        });
    });
  }
}
